import api from '@/api/Api'
import { EventBus } from '@utils/EventBus'
import Task, { TaskStatus } from '@models/task/task'
import store from '../store'

let subscribedChannels = []

// Helper function to subscribe to task channel
function subscribeToTaskChannel(el, taskName, channelName, wsId, folderId, commit, dispatch) {
  let channel = window.Echo.private(channelName)
    .listen('TaskStatusChange', (e) => {
      commit('UPDATE_TASK_STATUS', { taskId: el.id, data: e.message })
      if (e.message.task_status === 100 || e.message.task_status === -100 || e.message.task_status === -200) {
        if (e.message.download_url) window.open(e.message.download_url, '_blank')
        window.Echo.leave(channelName)
        let index = subscribedChannels.findIndex(val => val.name === taskName)
        if (index > -1) {
          subscribedChannels.splice(index, 1)
        }
        store.dispatch('imagery/getCurrentRouter').then(res => {
          if (!res || res === folderId) {
            dispatch('imagery/fetchFolderV2', { workspaceId: wsId, reset: true }, { root: true })
          } else {
            dispatch('imagery/fetchFolderV2', { workspaceId: wsId, folderId: res, reset: true }, { root: true })
          }
        })
        dispatch('model/selectFolder', { workspaceId: wsId, folderId: folderId, reset: true }, { root: true })
        let tmp = { workspaceId: wsId, taskID: el.id }
        dispatch('getTask', tmp)
        dispatch('imagery/fetchImagery', wsId, { root: true })
        dispatch('result/fetchResult', wsId, { root: true })
        dispatch('model/fetchModel', wsId, { root: true })
        dispatch('vector/fetchVector', wsId, { root: true })
        dispatch('table/fetchTable', wsId, { root: true })
        commit('UPDATE_PREPARE_TASK')
      }
    })
    .listen('TaskProccessingPercent', (e) => {
      commit('UPDATE_TASK_PROCESS', { taskId: el.id, data: e })
    })
    .listen('TaskPositionInQueueChange', (e) => {
      commit('UPDATE_TASK_IN_QUEUE', { taskId: el.id, data: e })
    })
  
  channel.name = taskName
  subscribedChannels.push(channel)
}

export const state = {
  tasks: [],
  taskEvent: new EventBus(),
  prepareTask: true
}

export const getters = {
  tasks (state) {
    return state.tasks
  },
  prepareTask (state) {
    return state.prepareTask
  }
}

export const mutations = {
  UPDATE_PREPARE_TASK (state) {
    state.prepareTask = !state.prepareTask
  },
  LOADING_TASK (state, data) {
    switch (data.type) {
      case 'resubmit':
        state.tasks.map(val => {
          if (val.id === data.id) {
            val.loading = data.loading
          }
          return state.tasks
        })
        break
      case 'cancel':
        state.tasks.map(val => {
          if (val.id === data.id) {
            val.loadingCancel = data.loading
          }
          return state.tasks
        })
        break
    }
  },
  SET_TASK (state, newValue) {
    state.tasks = newValue
  },
  UPDATE_TASK_PROCESS (state, form) {
    let tmp = state.tasks.find(value => value.id === form.taskId)
    tmp.percent = form.data.percentage * 100
  },
  UPDATE_TASK_STATUS (state, form) {
    let task = state.tasks.find(value => value.id === form.taskId)
    if (task) {
      task.status = new TaskStatus(form.data.task_status)
    }
  },
  UPDATE_TASK (state, newValue) {
    let index = state.tasks.findIndex(value => value.id === newValue.id)
    state.tasks.splice(index, 1, newValue)
    state.taskEvent.$emit('taskChange', newValue)
  },
  UPDATE_TASK_IN_QUEUE (state, form) {
    let tmp = state.tasks.find(value => value.id === form.taskId)
    tmp.inQueue = form.position_in_queue
  }
}

export const actions = {
  restartTask ({ commit, dispatch, state, rootState }, form) {
    return api.onRestartTask(form).then((response) => {
      const workspaceId = form.workspaceId || rootState.auth.currentWorkspace
      const taskId = form.taskId
      
      return dispatch('getTask', { workspaceId: workspaceId, taskID: taskId }).then(() => {
        const task = state.tasks.find(t => t.id === taskId)
        
        if (task) {
          setTimeout(() => {
            dispatch('initListen', { workspaceId: workspaceId, tasks: [task], forceSubscribe: true })
          }, 100)
        }
        
        return response
      })
    })
  },
  reCallApi ({ commit, dispatch, state }, data) {
    return api.reCallApi(data)
  },
  fetchTask ({ commit, dispatch, state }, workspaceId) {
    return api.getTasks(workspaceId, undefined).then((response) => {
      const tasks = response.data.data.map(el => {
        return new Task(el)
      })
      // store.dispatch('auth/getMe')
      commit('SET_TASK', tasks)
      dispatch('initListen', { workspaceId: workspaceId, tasks: tasks })
      return tasks
    })
  },
  refresh ({ commit, dispatch, state }, data) {
    return api.getTasks(data.workspaceId, data).then((response) => {
      const tasks = response.data.data.map(el => {
        return new Task(el)
      })
      // store.dispatch('auth/getMe')
      commit('SET_TASK', tasks)
      dispatch('initListen', { workspaceId: data.workspaceId, tasks: tasks, folderId: data.folderId })
      return tasks
    })
  },
  pushTask ({ commit, dispatch, state }, task) {
    const newTasksList = [...state.tasks]
    if (!newTasksList.find((x) => {
      return x.id == task.id
    })) {
      newTasksList.push(task)
    }
    commit('SET_TASK', newTasksList)
  },
  getTask ({ commit, dispatch, state }, form) {
    return api.getTaskChange(form).then((response) => {
      let task = new Task(response.data.data)
      commit('UPDATE_TASK', task)
    })
  },
  updateTask ({ commit, state }, form) {
    commit('UPDATE_TASK_PROCESS', form)
  },
  cancelTask ({ commit, dispatch, state }, form) {
    return api.cancelTask(form).then((response) => {
      return response
    })
  },
  afterSelectWorkspace ({ commit, dispatch, rootState }) {
    let workspaceId = rootState.auth.currentWorkspace
    dispatch('fetchTask', workspaceId)
  },
  initListen ({ commit, state, dispatch }, data) {
    let tasks = data.tasks
    let wsId = data.workspaceId
    let folderId = data.folderId ? data.folderId : undefined
    let forceSubscribe = data.forceSubscribe || false
    
    let needListenTasks = forceSubscribe 
      ? tasks 
      : tasks.filter(task => task.status.isCreated || task.status.isProcessing)
    
    needListenTasks.forEach(el => {
      let taskName = `private-task.${el.id}`
      let channelName = `task.${el.id}`
      
      let existingChannelIndex = subscribedChannels.findIndex(val => val.name === taskName)
      if (existingChannelIndex > -1) {
        if (forceSubscribe) {
          try {
            window.Echo.leave(channelName)
          } catch (err) {
            console.error('Error leaving channel:', err)
          }
          subscribedChannels.splice(existingChannelIndex, 1)
          
          setTimeout(() => {
            subscribeToTaskChannel(el, taskName, channelName, wsId, folderId, commit, dispatch)
          }, 500)
          return
        } else {
          return
        }
      }
      
      subscribeToTaskChannel(el, taskName, channelName, wsId, folderId, commit, dispatch)
    })
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/task.js